<div mat-dialog-title class="add-user__title">{{
  'addUser' | translate | async
}}</div>
<mat-dialog-content>
  <div class="add-user__form">
    <div>
      {{ data.description }}
    </div>
    <form [formGroup]="form" class="form-fields">
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>{{ 'email' | translate | async }}</mat-label>
        <input
          matInput
          type="email"
          placeholder="Email"
          formControlName="email"
          required
        />
        @if (form.controls.email.touched && form.controls.email.invalid) {
        <mat-icon matSuffix class="material-symbols-rounded">error</mat-icon>
        } @if (form.controls.email.invalid) {
        <mat-error>
          {{
            form.controls.email.hasError('required')
              ? ('emailRequired' | translate | async)
              : ''
          }}
          {{
            form.controls.email.hasError('email')
              ? ('emailValid' | translate | async)
              : ''
          }}
          {{
            form.controls.email.hasError('emailExists')
              ? ('emailInUse' | translate | async)
              : ''
          }}
        </mat-error>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        [class.role-selected]="!!form.controls.userRole.value"
        class="no-subscript-wrapper"
      >
        <mat-select [placeholder]="('role' | translate | async) ?? ''" formControlName="userRole" required>
          <mat-select-trigger class="trigger">
            <mat-icon>
              {{ form.controls.userRole.value?.icon?.name ?? '' }}
            </mat-icon>
            <span>{{ form.controls.userRole.value?.name ?? '' }}</span>
          </mat-select-trigger>
          @for (role of rolesStore.entities(); track role) {
          <mat-option [value]="role" class="role-option">
            <mat-icon> {{ role.icon.name }} </mat-icon>
            <span class="role-user">{{ role.name }}</span>
          </mat-option>
          }
        </mat-select>
        @if (form.controls.userRole.invalid) {
        <mat-error> {{ 'roleRequired' | translate | async }}</mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close(false)">{{
    'cancel' | translate | async
  }}</button>
  <button
    mat-button
    (click)="dialogRef.close(this.form.getRawValue())"
    [disabled]="form.invalid"
  >
    {{ 'addUser' | translate | async }}
  </button>
</mat-dialog-actions>
